// =============================================================================
// T-486 — « Aides complémentaires » : UNE entrée du Hub Conformité, deux onglets.
//   · Aides par client  = pour chaque client, ce à quoi il peut prétendre d'après son dossier (le verdict du code) et ce qu'il faut saisir pour conclure ;
//   · Campagne          = le mail d'offre envoyé par lots (ex-« Offre d'aides » du Hub Communication) ; réservé à qui peut ouvrir le Bureau (verdict serveur).
// Aucune règle ici : les deux écrans gardent leur propre serveur, leurs gardes et leurs tests.
// =============================================================================
import { useState } from "react";
import AidesParClientPage from "./AidesParClientPage";
import OffreAides from "../omnihub/communication/OffreAides";
import Bouton from "../omnihub/communication/boutonBureau";

export const ONGLETS_AIDES = [["clients", "Aides par client"], ["campagne", "Campagne"]];

export default function AidesComplementaires({ tenantId, onOpenDossier, peutCampagne = false, ongletInitial = "clients" }) {
  const [onglet, setOnglet] = useState(peutCampagne || ongletInitial !== "campagne" ? ongletInitial : "clients");
  const onglets = ONGLETS_AIDES.filter(([cle]) => cle !== "campagne" || peutCampagne);
  return (
    <div data-testid="aides-complementaires">
      <div className="flex flex-wrap items-center gap-2" role="tablist" aria-label="Aides complémentaires" style={{ padding: "var(--oh-space-4) var(--oh-space-4) 0" }}>
        {onglets.map(([cle, libelle]) => (
          <Bouton key={cle} type={onglet === cle ? "secondaire" : "discret"} role="tab" aria-selected={onglet === cle} data-testid={`aides-onglet-${cle}`}
            style={{ height: 44 }} onClick={() => setOnglet(cle)}>{libelle}</Bouton>
        ))}
      </div>
      {onglet === "campagne" && peutCampagne ? <div style={{ padding: "var(--oh-space-4)" }}><OffreAides /></div> : <AidesParClientPage tenantId={tenantId} onOpenDossier={onOpenDossier} />}
    </div>
  );
}
